import React, { use, useState } from 'react';
import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';
import { getDateShowingInActions, updateDateShowingInActions } from '@soulhx/client-store';
import { useGetActionTypes } from '../../hooks/GetActions.js';
import { useGetActionEntriesForMonth } from '../../hooks/GetActionEntries.js';
import { type CalendarCalloutItem } from '../common/calendar/helpers/dm.js';
import { CalendarWidget } from '../common/calendar/CalendarWidget.js';
import { handleInit } from '@soulhx/ui-common';
import { SoulHXContext, type SoulHXContextType } from '../../stores/SoulHXContext.js';

interface ICalendarView {
  close?: () => void;
}
export const CalendarView = ({ close }: ICalendarView) => {
  const dateToShow = DateTime.fromISO(useSelector(getDateShowingInActions));
  const [dateForComponent, setDateForComponent] = useState<DateTime>(dateToShow);
  const dispatch = useDispatch();
  const { entries, entriesLoading } = useGetActionEntriesForMonth(
    dateForComponent.year.toString(),
    dateForComponent.month.toString()
  );
  const { user } = use(SoulHXContext) as SoulHXContextType;
  const { actionTypes, actionTypesLoading } = useGetActionTypes();

  const resp = handleInit([entriesLoading, actionTypesLoading], []);
  if (resp) return resp;

  const callouts: CalendarCalloutItem[] = [];
  const availableTypes = actionTypes!.map((t) => t.displayName);
  for (const t of availableTypes) {
    callouts.push({ name: t, dates: new Set<string>() });
  }

  for (const a of entries!) {
    const dateToUse = DateTime.fromISO(a.entryDate).toISODate()!;
    const indexOfItem = callouts.findIndex((i) => i.name === a.displayName);
    if (indexOfItem < 0) continue;

    callouts[indexOfItem].dates.add(dateToUse);
  }

  return (
    <CalendarWidget
      dateToShow={dateToShow}
      selectNewDate={(value) => {
        const dateToDispatch = DateTime.fromJSDate(value);
        dispatch(updateDateShowingInActions(dateToDispatch.toISO()!));
        if (close) close();
      }}
      startDateChange={(activeStartDate) => {
        const monthDateToShow = DateTime.fromJSDate(activeStartDate);
        setDateForComponent(monthDateToShow);
      }}
      maxDate={DateTime.now()}
      minDate={DateTime.fromISO(user.signupDate)}
      callouts={callouts}
      settingName="doCalendarActions"
    />
  );
};
